import React from 'react';

function LoadingSpinner({ size = 'medium', message = 'Loading...' }) {
  const sizeMap = {
    small: { spinner: 20, border: 2 },
    medium: { spinner: 32, border: 3 },
    large: { spinner: 48, border: 4 },
  };

  const { spinner, border } = sizeMap[size] || sizeMap.medium;

  return (
    <div style={styles.container}>
      <div
        style={{
          ...styles.spinner,
          width: spinner,
          height: spinner,
          borderWidth: border,
        }}
      />
      {message && <p style={styles.message}>{message}</p>}
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.85rem',
    padding: '2rem',
  },
  spinner: {
    borderStyle: 'solid',
    borderColor: 'rgba(0, 0, 0, 0.08)',
    borderTopColor: '#000000',
    borderRadius: '50%',
    animation: 'spin 0.8s linear infinite',
  },
  message: {
    fontFamily: "'Inter', sans-serif",
    color: '#999999',
    fontSize: '0.9rem',
    fontWeight: 400,
    letterSpacing: '0.01em',
    margin: 0,
  },
};

export default LoadingSpinner;
